(function () {
  var state = window.haidaGA4 || {};

  if (!state.measurementId || !state.eventsEnabled || state.designMode || state.eventsLoaded) return;

  state.eventsLoaded = true;

  var sent = {};
  var currency = state.currency || 'USD';

  function clean(value) {
    if (Array.isArray(value)) {
      return value.map(clean).filter(function (item) {
        return item && Object.keys(item).length;
      });
    }

    if (!value || typeof value !== 'object') return value;

    return Object.keys(value).reduce(function (result, key) {
      var item = clean(value[key]);
      if (item === undefined || item === null || item === '') return result;
      if (Array.isArray(item) && !item.length) return result;
      result[key] = item;
      return result;
    }, {});
  }

  function send(name, params) {
    if (typeof window.gtag !== 'function') return;
    window.gtag('event', name, clean(params || {}));
  }

  function sendOnce(key, name, params) {
    if (sent[key]) return;
    sent[key] = true;
    send(name, params);
  }

  function textContent(root, selector) {
    var element = root && root.querySelector(selector);
    return element ? element.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function numericText(value) {
    if (!value) return undefined;
    var match = String(value).replace(/,/g, '').match(/-?\d+(\.\d+)?/);
    return match ? Number(match[0]) : undefined;
  }

  function normalizeItem(item, index, listName) {
    if (!item) return {};
    var normalized = {
      item_id: item.item_id || item.variant_id || item.id,
      item_group_id: item.item_group_id || item.product_id,
      item_name: item.item_name || item.product_title || item.title,
      item_brand: item.item_brand || item.vendor,
      item_category: item.item_category || item.product_type,
      item_variant: item.item_variant || item.variant_title,
      item_handle: item.item_handle || item.handle,
      item_url: item.item_url || item.url,
      price: item.price !== undefined ? Number(item.price) : numericText(item.final_price),
      quantity: Number(item.quantity || 1),
    };

    if (index !== undefined) normalized.index = index;
    if (listName) normalized.item_list_name = listName;

    return clean(normalized);
  }

  function itemFromProductCard(card, index, listName) {
    var link = card.querySelector('a[href*="/products/"]');
    var title = textContent(card, '.product-item__name') || (link ? link.getAttribute('aria-label') : '');
    var formVariant = card.querySelector('form[action*="/cart/add"] [name="id"], form[data-type="add-to-cart-form"] [name="id"]');
    var productButton = card.querySelector('[data-product-id]');
    var url = link ? link.href : '';
    var handle = '';

    if (url) {
      handle = url.split('/products/')[1] || '';
      handle = handle.split(/[?#/]/)[0];
    }

    return normalizeItem(
      {
        item_id: formVariant ? formVariant.value : handle || (productButton ? productButton.dataset.productId : ''),
        item_group_id: productButton ? productButton.dataset.productId : '',
        item_name: title,
        item_handle: handle,
        item_url: url,
        price: numericText(textContent(card, '.price, .product-item__price')),
      },
      index,
      listName
    );
  }

  function listNameForCard(card) {
    var section = card.closest('[data-section-id], [data-section]');
    if (section && (section.dataset.sectionId || section.dataset.section)) {
      return section.dataset.sectionId || section.dataset.section;
    }
    return (state.page && state.page.title) || (document.title || '').trim();
  }

  function sendProductPageEvents() {
    if (!state.product) return;
    var item = normalizeItem(state.product);
    sendOnce('view_item:' + (item.item_id || item.item_handle || location.pathname), 'view_item', {
      currency: currency,
      value: item.price,
      items: [item],
    });
  }

  function sendSearchEvent() {
    if (!state.search || !state.search.term) return;
    sendOnce('search:' + state.search.term, 'search', {
      search_term: state.search.term,
      result_count: state.search.results,
    });
  }

  function sendProductListEvents() {
    var cards = Array.prototype.slice.call(document.querySelectorAll('.product-item')).filter(function (card) {
      return card.querySelector('a[href*="/products/"]');
    });
    var items = cards.slice(0, 50).map(function (card, index) {
      return itemFromProductCard(card, index + 1, listNameForCard(card));
    }).filter(function (item) {
      return item.item_id || item.item_name;
    });

    if (!items.length) return;

    sendOnce('view_item_list:' + location.pathname + ':' + items.map(function (item) {
      return item.item_id || item.item_name;
    }).join('|'), 'view_item_list', {
      item_list_name: (state.page && state.page.title) || document.title,
      items: items,
    });
  }

  function trackSelectedProduct(event) {
    var link = event.target.closest('a[href*="/products/"]');
    if (!link) return;

    var card = link.closest('.product-item');
    if (!card) return;

    var cards = Array.prototype.slice.call(document.querySelectorAll('.product-item'));
    var item = itemFromProductCard(card, cards.indexOf(card) + 1, listNameForCard(card));
    if (!item.item_id && !item.item_name) return;

    send('select_item', {
      item_list_name: item.item_list_name,
      items: [item],
    });
  }

  function itemFromCartAddPayload(data) {
    var cartData = data && data.cartData ? data.cartData : data;

    if (cartData && Array.isArray(cartData.items) && cartData.items.length) {
      return cartData.items.map(function (item) {
        return normalizeItem({
          item_id: item.variant_id || item.id,
          item_group_id: item.product_id,
          item_name: item.product_title || item.title,
          item_brand: item.vendor,
          item_category: item.product_type,
          item_variant: item.variant_title,
          item_handle: item.handle,
          item_url: item.url,
          price: item.final_price !== undefined ? item.final_price / 100 : item.price,
          quantity: item.quantity,
        });
      });
    }

    return [
      normalizeItem({
        item_id: data && data.productVariantId ? data.productVariantId : cartData && (cartData.variant_id || cartData.id),
        item_group_id: cartData && cartData.product_id,
        item_name: cartData && (cartData.product_title || cartData.title),
        item_brand: cartData && cartData.vendor,
        item_category: cartData && cartData.product_type,
        item_variant: cartData && cartData.variant_title,
        item_handle: cartData && cartData.handle,
        item_url: cartData && cartData.url,
        price: cartData && cartData.final_price !== undefined ? cartData.final_price / 100 : cartData && cartData.price,
        quantity: cartData && cartData.quantity,
      }),
    ];
  }

  function refreshCart() {
    fetch('/cart.js')
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (cart) {
        if (!cart) return;
        state.cart = {
          value: cart.total_price / 100,
          items: (cart.items || []).map(function (item) {
            return normalizeItem({
              item_id: item.variant_id || item.id,
              item_group_id: item.product_id,
              item_name: item.product_title || item.title,
              item_brand: item.vendor,
              item_category: item.product_type,
              item_variant: item.variant_title,
              item_handle: item.handle,
              item_url: item.url,
              price: item.final_price !== undefined ? item.final_price / 100 : item.price,
              quantity: item.quantity,
            });
          }),
        };
      })
      .catch(function () {});
  }

  function trackAddToCart(data) {
    var items = itemFromCartAddPayload(data).filter(function (item) {
      return item.item_id || item.item_name;
    });
    if (!items.length) return;

    var value = items.reduce(function (sum, item) {
      return sum + Number(item.price || 0) * Number(item.quantity || 1);
    }, 0);

    send('add_to_cart', {
      currency: currency,
      value: value || undefined,
      items: items,
    });
    refreshCart();
  }

  function setupCartUpdateSubscription() {
    var subscribeFn = window.subscribe || (typeof subscribe === 'function' ? subscribe : null);
    if (!subscribeFn) return;

    subscribeFn('cart-update', function (data) {
      trackAddToCart(data);
    });
  }

  function trackBeginCheckout() {
    var cart = state.cart || {};
    send('begin_checkout', {
      currency: currency,
      value: cart.value,
      items: cart.items || [],
    });
  }

  function isLeadUrl(url) {
    if (!url) return false;
    return /mailto:|tel:|wa\.me|whatsapp\.com|\/pages\/request-quote|\/pages\/contact/i.test(url);
  }

  function compactText(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function ctaMeta(type) {
    if (type === 'whatsapp' || type === 'wechat') {
      return { priority: 1, tier: 'primary' };
    }

    if (type === 'contact_form' || type === 'request_quote' || type === 'contact_page') {
      return { priority: 2, tier: 'secondary' };
    }

    if (type === 'newsletter' || type === 'email' || type === 'phone') {
      return { priority: 3, tier: 'tertiary' };
    }

    return { priority: 4, tier: 'other' };
  }

  function hasLeadMarker(target) {
    if (!target) return false;
    return (target.classList && target.classList.contains('js-cta')) ||
      target.hasAttribute('data-fcs-wechat-btn') ||
      target.hasAttribute('data-mobile-wechat-btn') ||
      target.hasAttribute('data-mobile-wechat-save');
  }

  function inferCtaType(target, href, channel) {
    var className = target && target.className ? String(target.className) : '';

    if (channel) return channel;
    if (target && (
      target.hasAttribute('data-fcs-wechat-btn') ||
      target.hasAttribute('data-mobile-wechat-btn') ||
      target.hasAttribute('data-mobile-wechat-save') ||
      /wechat/i.test(className)
    )) return 'wechat';
    if (/wa\.me|whatsapp\.com|whatsapp:\/\//i.test(href)) return 'whatsapp';
    if (/^mailto:/i.test(href)) return 'email';
    if (/^tel:/i.test(href)) return 'phone';
    if (/\/pages\/request-quote/i.test(href)) return 'request_quote';
    if (/\/pages\/contact/i.test(href)) return 'contact_page';
    return 'cta';
  }

  function inferCtaAction(target, type, actionOverride) {
    if (actionOverride) return actionOverride;
    if (target && target.hasAttribute('data-mobile-wechat-save')) return 'save_qr';
    if (type === 'wechat') return 'open_qr';
    return 'click';
  }

  function analyticsLink(href) {
    if (/^(mailto|tel):/i.test(href)) return href.split(':')[0] + ':';
    try {
      var url = new URL(href, window.location.origin);
      return url.origin + url.pathname;
    } catch (error) {
      return '';
    }
  }

  function trackCtaElement(target, actionOverride) {
    if (!target) return;

    var href = target.href || '';
    var label = target.dataset.ctaLabel || target.getAttribute('aria-label') || target.textContent || '';
    var channel = target.dataset.ctaChannel || '';

    if (!hasLeadMarker(target) && !isLeadUrl(href)) return;

    var ctaType = inferCtaType(target, href, channel);
    var action = inferCtaAction(target, ctaType, actionOverride);
    var meta = ctaMeta(ctaType);
    var params = {
      cta_type: ctaType,
      cta_action: action,
      cta_priority: meta.priority,
      lead_tier: meta.tier,
      method: ctaType,
      link_url: analyticsLink(href),
      link_text: compactText(label),
      cta_channel: ctaType,
      cta_label: compactText(label).slice(0, 100),
      cta_position: target.dataset.ctaPosition,
    };

    if (ctaType === 'wechat' && action === 'open_qr') {
      if (target.dataset.ga4WechatQrOpenTracked === 'true') return;
      target.dataset.ga4WechatQrOpenTracked = 'true';
    }

    send('cta_click', params);

  }

  function trackLeadClick(event) {
    if (!event.target || !event.target.closest) return;
    trackCtaElement(event.target.closest('.js-cta, [data-fcs-wechat-btn], [data-mobile-wechat-btn], [data-mobile-wechat-save], a[href]'));
  }

  function trackFormSubmit(event) {
    var form = event.target;
    if (!form || form.nodeName !== 'FORM') return;

    var action = form.getAttribute('action') || '';
    var email = form.querySelector('input[name="contact[email]"], input[type="email"]');
    var tags = form.querySelector('input[name="contact[tags]"]');
    var isContact = action.indexOf('/contact') > -1 || form.querySelector('[name^="contact["]');
    var isNewsletter = form.className.indexOf('newsletter') > -1 || form.id.toLowerCase().indexOf('newsletter') > -1 || (tags && tags.value.indexOf('newsletter') > -1);

    if (!isContact || event.defaultPrevented) return;
    if (typeof form.checkValidity === 'function' && !form.checkValidity()) return;

    if (isNewsletter) {
      var newsletterMeta = ctaMeta('newsletter');
      send('cta_click', {
        cta_type: 'newsletter',
        cta_action: 'submit',
        cta_priority: newsletterMeta.priority,
        lead_tier: newsletterMeta.tier,
        method: 'newsletter',
        form_id: form.id,
        form_name: form.getAttribute('name'),
        email_provided: !!(email && email.value),
      });
      send('newsletter_submit_attempt', {
        method: 'newsletter',
      });
      return;
    }

    var formMeta = ctaMeta('contact_form');
    var formParams = {
      cta_type: 'contact_form',
      cta_action: 'submit',
      cta_priority: formMeta.priority,
      lead_tier: formMeta.tier,
      method: 'form',
      form_id: form.id,
      form_name: form.getAttribute('name'),
      email_provided: !!(email && email.value),
      cta_channel: 'form',
    };

    send('inquiry_submit_attempt', formParams);
    var occurrence = window.crypto && typeof window.crypto.randomUUID === 'function'
      ? window.crypto.randomUUID()
      : Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
    try {
      window.sessionStorage.setItem('haida:inquiry:' + form.id, JSON.stringify({
        occurrence_id: occurrence, submitted_at: Date.now(), path: window.location.pathname
      }));
    } catch (error) {}
  }

  function trackFormResult() {
    Array.prototype.slice.call(document.querySelectorAll('[data-haida-inquiry-result]')).forEach(function (marker) {
      var form = marker.closest('form');
      if (!form) return;
      var key = 'haida:inquiry:' + form.id;
      var pending;
      try {
        pending = JSON.parse(window.sessionStorage.getItem(key) || 'null');
      } catch (error) { return; }
      if (!pending || !pending.occurrence_id || pending.path !== window.location.pathname) return;
      try { window.sessionStorage.removeItem(key); } catch (error) { return; }
      var age = Date.now() - pending.submitted_at;
      if (age < 0 || age > 30 * 60 * 1000) return;
      var result = marker.getAttribute('data-haida-inquiry-result');
      if (result !== 'accepted' && result !== 'error') return;
      sendOnce('inquiry:' + pending.occurrence_id, result === 'accepted' ? 'generate_lead' : 'inquiry_form_error', {
        lead_source: 'shopify_contact_form', method: 'form', cta_channel: 'form',
        form_id: form.id, occurrence_id: pending.occurrence_id, tracking_version: 'accepted-v2'
      });
    });
  }

  function setupWechatQrTracking() {
    Array.prototype.slice.call(document.querySelectorAll('[data-fcs-wechat-btn]')).forEach(function (button) {
      button.addEventListener('mouseenter', function () {
        if ('ontouchstart' in window || navigator.maxTouchPoints > 0) return;
        trackCtaElement(button, 'open_qr');
      });
    });
  }

  function setupCheckoutClicks() {
    document.addEventListener('click', trackLeadClick, true);

    document.addEventListener('click', function (event) {
      var checkout = event.target.closest('button[name="checkout"], a[href*="/checkout"], .shopify-payment-button__button');
      if (checkout && !checkout.disabled && checkout.getAttribute('aria-disabled') !== 'true') {
        trackBeginCheckout();
      }

      trackSelectedProduct(event);
    });
  }

  function setupForms() {
    document.addEventListener('submit', trackFormSubmit, true);
  }

  function init() {
    sendProductPageEvents();
    sendSearchEvent();
    sendProductListEvents();
    setupCartUpdateSubscription();
    setupCheckoutClicks();
    setupForms();
    trackFormResult();
    setupWechatQrTracking();
    refreshCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.haidaTrack = send;
  window.haidaTrackGA4 = send;
})();
